var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRakete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 67,
    viewBox: "0 0 229 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2752 31.217C33.8809 30.7038 33.7183 30.0867 33.7695 29.4908C33.8267 28.8166 34.1563 28.1694 34.7357 27.7255C35.8268 26.8887 37.3889 27.0949 38.2257 28.186C38.6199 28.6977 38.7825 29.3162 38.7313 29.9122C38.6741 30.5864 38.3445 31.2335 37.7651 31.6775C36.6741 32.5142 35.1119 32.308 34.2752 31.217Z",
    fill: "url(#paint0_linear_1965_74120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7141 2.08309V2.9063C81.6795 2.69862 81.6705 2.48793 81.6886 2.28024C81.6946 2.21403 81.7021 2.14781 81.7141 2.08309Z",
    fill: "url(#paint1_linear_1965_74120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.911 15.3585H109.065C109.346 15.3103 109.632 15.3118 109.911 15.3585Z",
    fill: "url(#paint2_linear_1965_74120)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2693 33.1841C57.2693 40.5313 54.8825 47.3201 50.8402 52.8177C49.8484 54.1691 48.7558 55.4408 47.5744 56.6252C41.5847 62.6269 33.3075 66.3472 24.1604 66.3682H8.42019C8.34946 66.3697 8.27872 66.3713 8.20799 66.3713C3.67508 66.3713 0 62.6962 0 58.1633C0 56.857 0.305505 55.6214 0.850296 54.5243C1.01434 54.2248 1.1859 53.9283 1.36198 53.6349C3.16039 50.6325 5.48403 47.9823 8.20799 45.8106C12.6882 42.2334 18.2475 39.9519 24.3185 39.5335C24.5337 41.6163 24.1138 43.7338 23.0995 45.5849C22.4388 46.7874 21.5298 47.8769 20.3785 48.7709C21.8052 48.795 23.2394 48.5542 24.6059 48.0335C25.6187 47.6497 26.5909 47.1139 27.4939 46.4217C29.6776 44.7466 31.0862 42.435 31.6566 39.9444C31.6852 39.824 31.7108 39.7021 31.7349 39.5802C33.6958 39.4146 35.6598 38.8864 37.5319 37.9684C42.8895 35.3392 46.1628 30.1637 46.6098 24.618C44.2967 23.11 41.6299 22.207 38.8758 22.0024C36.0811 21.7947 33.1947 22.3063 30.4978 23.6292C29.5256 24.1063 28.6211 24.6676 27.7919 25.2997C27.0214 25.8851 26.314 26.5292 25.6744 27.2275C25.2922 27.0364 24.9009 26.8663 24.5021 26.7219C21.3146 25.5495 17.6666 25.8279 14.6266 27.6956C14.291 27.9002 13.9644 28.126 13.6454 28.3698C12.7981 29.0199 12.0667 29.7679 11.4557 30.5836C12.8327 30.2314 14.2579 30.1697 15.6424 30.3879C16.1601 30.4692 16.6718 30.5896 17.1715 30.7491C13.9795 32.7823 10.9816 35.0939 8.20799 37.6463V0H24.1604C35.2263 0.0255841 45.0205 5.46748 51.0328 13.8154C51.3955 14.3181 51.7447 14.8328 52.0788 15.358C53.1804 17.0812 54.1255 18.9142 54.896 20.8345C56.4265 24.6526 57.2693 28.8198 57.2693 33.1841Z",
    fill: "url(#paint3_linear_1965_74120)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7141 2.08309V2.9063C81.6795 2.69862 81.6705 2.48793 81.6886 2.28024C81.6946 2.21403 81.7021 2.14781 81.7141 2.08309Z",
    fill: "url(#paint4_linear_1965_74120)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6886 2.28024C81.6705 2.48793 81.6795 2.69862 81.7141 2.9063L81.7142 58.6931C81.7142 62.9325 78.2754 66.3713 74.0344 66.3713C69.7935 66.3713 66.3562 62.9325 66.3562 58.6931V15.3235C57.8939 15.3235 51.0328 8.46241 51.0328 8.68607e-05H81.7142L81.7141 2.08309C81.7021 2.14781 81.6946 2.21403 81.6886 2.28024Z",
    fill: "url(#paint5_linear_1965_74120)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 8.68607e-05V58.6931C102.017 62.9325 98.5786 66.3713 94.3377 66.3713C90.0967 66.3713 86.6594 62.9325 86.6594 58.6931V8.68607e-05H102.017Z",
    fill: "url(#paint6_linear_1965_74120)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.642 8.68607e-05V0.0347007C129.642 8.49703 122.783 15.3581 114.319 15.3581L109.911 15.3585C109.632 15.3118 109.346 15.3103 109.065 15.3585L106.997 15.3581V8.68607e-05H129.642Z",
    fill: "url(#paint7_linear_1965_74120)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.608 27.9488C129.608 32.1898 126.17 35.6271 121.929 35.6271H106.963V20.2691H109.071C109.345 20.3142 109.625 20.3157 109.902 20.2691H121.929C126.17 20.2691 129.608 23.7079 129.608 27.9488Z",
    fill: "url(#paint8_linear_1965_74120)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 20.2691H109.902C109.625 20.3157 109.345 20.3142 109.071 20.2691Z",
    fill: "url(#paint9_linear_1965_74120)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7141 2.08309V2.9063C81.6795 2.69862 81.6705 2.48793 81.6886 2.28024C81.6946 2.21403 81.7021 2.14781 81.7141 2.08309Z",
    fill: "url(#paint10_linear_1965_74120)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 20.2691C109.345 20.3142 109.625 20.3157 109.902 20.2691H109.071Z",
    fill: "url(#paint11_linear_1965_74120)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.911 15.3585H109.065C109.346 15.3103 109.632 15.3118 109.911 15.3585Z",
    fill: "url(#paint12_linear_1965_74120)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.221 38.25H159.95V52.0448C160.705 51.4287 161.376 50.8852 162.044 50.337C163.111 49.465 164.172 48.5866 165.245 47.7225C165.373 47.6198 165.561 47.5408 165.722 47.5408C168.041 47.5297 170.36 47.5329 172.68 47.5345C172.733 47.5345 172.785 47.5439 172.961 47.5613C169.166 50.6672 165.458 53.702 161.732 56.7526C165.46 59.8047 169.176 62.8459 172.961 65.9423C172.771 65.9565 172.662 65.9723 172.555 65.9723C170.31 65.9723 168.065 65.9802 165.82 65.9628C165.608 65.9628 165.36 65.8633 165.193 65.729C163.473 64.3419 161.766 62.9391 159.984 61.4825V65.9423H154.22V38.25H154.221Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.712 65.9359H144.019C143.998 65.8332 143.976 65.7211 143.953 65.5994C143.915 65.6026 143.87 65.5963 143.836 65.6105C141.11 66.6863 138.404 66.631 135.79 65.3182C133.316 64.0781 131.659 62.0781 130.881 59.4193C130.164 56.9706 130.379 54.563 131.587 52.3086C133.098 49.4902 135.447 47.7382 138.633 47.2596C142.997 46.6055 147.011 48.7809 148.875 52.7541C149.4 53.8726 149.7 55.0622 149.706 56.3086C149.72 59.424 149.733 62.5394 149.744 65.6547C149.744 65.74 149.727 65.8269 149.714 65.9328L149.712 65.9359ZM140.065 60.5804C142.268 60.5773 144.022 58.86 143.962 56.6657C143.905 54.5946 142.349 52.8868 140.099 52.8963C137.851 52.9058 136.253 54.6293 136.265 56.7431C136.278 58.9469 137.96 60.5362 140.065 60.5804Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.432 59.6348C191.462 62.4247 189.718 64.4579 187.002 65.5574C183.12 67.1293 179.599 66.4089 176.547 63.6206C174.833 62.055 173.893 60.0344 173.676 57.6869C173.462 55.344 174.005 53.1955 175.33 51.2839C176.905 49.0122 179.098 47.6473 181.857 47.2444C184.312 46.8858 186.59 47.3898 188.632 48.7816C190.762 50.2318 192.125 52.2366 192.688 54.7658C192.77 55.1339 192.65 55.303 192.283 55.4341C188.509 56.7737 184.741 58.1339 180.972 59.4894C180.902 59.5147 180.841 59.5589 180.73 59.619C181.365 60.2398 182.127 60.521 182.967 60.5763C184.68 60.6901 186.144 59.7738 186.811 58.194C186.895 57.9965 186.975 57.908 187.204 57.9807C188.926 58.5321 190.653 59.0739 192.429 59.6348H192.432ZM179.436 56.1576C181.615 55.3661 183.673 54.6173 185.804 53.8432C184.482 52.8306 183.124 52.5873 181.667 53.235C180.455 53.7737 179.74 54.7374 179.436 56.1576Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.776 59.5983C218.423 61.1766 221.854 60.9807 223.017 57.908C224.829 58.4783 226.645 59.0486 228.459 59.6189C227.347 63.5636 223.263 66.7927 218.4 66.303C213.294 65.7896 209.598 61.5968 209.702 56.5541C209.805 51.5967 213.604 47.6014 218.435 47.1685C223.77 46.6914 228.157 50.5935 228.811 55.2539C226.819 55.968 224.811 56.6836 222.806 57.4072C220.81 58.1275 218.814 58.8558 216.776 59.5968V59.5983ZM215.509 56.1575C217.65 55.3787 219.724 54.6236 221.866 53.8431C220.476 52.7894 219.07 52.5746 217.588 53.3076C216.435 53.8779 215.75 54.8274 215.509 56.1575Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.37 41.1055H202.136V47.6553H206.407V52.3536H202.159C202.159 52.965 202.159 53.5116 202.159 54.0582C202.159 55.7518 202.157 57.4437 202.159 59.1373C202.16 60.2337 202.988 60.8276 204.05 60.5149C204.163 60.4817 204.378 60.5291 204.441 60.616C205.463 62.0283 206.468 63.4517 207.475 64.8751C207.516 64.932 207.531 65.0078 207.555 65.0694C204.683 67.1231 200.626 66.6634 198.285 64.0789C197.005 62.6665 196.384 61.0188 196.378 59.1468C196.359 53.2652 196.372 47.3852 196.372 41.5036V41.1055H196.37Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.396 47.1289V53.5761H124.845C123.516 53.5761 122.409 54.595 122.3 55.9189C122.295 55.9884 122.29 56.0579 122.29 56.129C122.29 56.2001 122.293 56.268 122.3 56.3391V66.3756H115.853V53.5776C115.867 50.031 118.745 47.1637 122.29 47.1621H122.3V47.1305H127.396V47.1289Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1965_74120",
    x1: 0,
    y1: 66.3713,
    x2: 129.642,
    y2: -0.0000014973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakete);
export default __webpack_public_path__ + "static/media/rakete.bab840c46ee410413d795022b5ad67eb.svg";
export { ForwardRef as ReactComponent };